export default __webpack_public_path__ + "static/media/searchFilterIcon.89c8fdb0.svg";